// Catalog prices come from the backend denominated in Kazakhstani tenge (KZT;
// the Good model's Money fields use "KZT"). Format them as "2 400 ₸":
// space-grouped thousands, symbol last, no fractional tiyn.
const tengeFormatter = new Intl.NumberFormat("ru-RU", {
  maximumFractionDigits: 0
});

export function formatPrice(amount: number): string {
  return `${tengeFormatter.format(amount)} ₸`;
}
